import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/device/shutdown/statistics',
    name: 'deviceShutdownStatisticsGet',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
